import {addPrefixToObjectKeys} from '../../../helpers/Utils';
import main from './es/main.json';
import admSection from './es/admSection.json';
import admSuperSection from './es/admSuperSection.json';
import admGroup from './es/admGroup.json';
import admInfirmary from './es/admInfirmary.json';
import admLocalization from './es/admLocalization.json';
import admPublication from './es/admPublication.json';
import admAssignment from './es/admAssignment.json';
import admJustification from './es/admJustification.json';
import admAttendance from './es/admAttendance.json';
import admUser from './es/admUser.json';
import admStudent from './es/admStudent.json';
import admModule from './es/admModule.json';
import admCommunications from './es/admCommunications.json';
import admCalendar from './es/admCalendar.json';
import admNotification from './es/admNotification.json';
import admFlow from './es/admFlow.json';
import admFlowInput from './es/admFlowInput.json';
import admPeriod from './es/admPeriod.json';
import admActivity from './es/admActivity.json';
import admRegist from './es/admRegist.json';

const m = addPrefixToObjectKeys(main, "main.");
const section = addPrefixToObjectKeys(admSection, "admSection.");
const superSection = addPrefixToObjectKeys(admSuperSection, "admSuperSection.");
const group = addPrefixToObjectKeys(admGroup, "admGroup.");
const infirmary = addPrefixToObjectKeys(admInfirmary, "admInfirmary.");
const localization = addPrefixToObjectKeys(admLocalization, "admLocalization.");
const publication = addPrefixToObjectKeys(admPublication, "admPublication.");
const assignment = addPrefixToObjectKeys(admAssignment, "admAssignment.");
const justification = addPrefixToObjectKeys(admJustification, "admJustification.");
const attendance = addPrefixToObjectKeys(admAttendance, "admAttendance.");
const user = addPrefixToObjectKeys(admUser, "admUser.");
const student = addPrefixToObjectKeys(admStudent, "admStudent.");
const modules = addPrefixToObjectKeys(admModule, "admModule.");
const communications = addPrefixToObjectKeys(admCommunications, "admCommunications.");
const calendar = addPrefixToObjectKeys(admCalendar, "admCalendar.");
const notification = addPrefixToObjectKeys(admNotification, "admNotification.");
const flow = addPrefixToObjectKeys(admFlow, "admFlow.");
const flowInput = addPrefixToObjectKeys(admFlowInput, "admFlowInput.");
const period = addPrefixToObjectKeys(admPeriod, "admPeriod.");
const activity = addPrefixToObjectKeys(admActivity, "admActivity.");
const regist = addPrefixToObjectKeys(admRegist, "admRegist.");

const r = {
  ...m, ...group, ...infirmary, ...publication, ...localization, ...assignment, ...section, ...superSection,
  ...justification, ...attendance, ...user, ...student, ...modules, ...communications, ...calendar, ...notification, ...flow, ...flowInput, ...period,
  ...activity, ...regist
}
export default r;